// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/icons/arrow.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
    margin: 0;
    padding: 0;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
        "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif,
        "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}

[data-arrow="left"],
[data-arrow="right"] {
    bottom: 0;
    height: 42px;
    margin-bottom: 24px;
    margin-top: auto;
    width: 39px;
    position: fixed;
    margin-left: 160px;
    opacity: 1;
    cursor: pointer;
    z-index: 999;
}

[data-arrow="left"] {
    background: linear-gradient(90deg,
            var(--chakra-colors-brand-500) 10%,
            hsla(0, 0%, 100%, 0));
    left: 0;
}

[data-arrow="right"] {
    background: linear-gradient(270deg,
            var(--chakra-colors-brand-500) 10%,
            hsla(0, 0%, 100%, 0));
    right: 0;
}

[data-arrow="left"]>button {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) 50% no-repeat;
    border: none;
    cursor: pointer;
    height: 40px;
    /* margin-left: 150px; */
    width: 100%;
    outline: 0;
    transform: rotate(180deg) scale(0.7);
}

[data-arrow="right"]>button {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) 50% no-repeat;
    border: none;
    cursor: pointer;
    height: 40px;
    width: 100%;
    outline: 0;
    position: absolute;
    transform: scale(0.7);
}

.menu-slider {
    padding-right: 4.25rem;
}

.tableMenu {
    .ant-table-cell-ellipsis {
        text-align: center;
    }

    .ant-table-body .ant-table-cell:not(.ant-table-cell-with-append) {
        text-align: center;
    }

    .ant-table-cell.ant-table-cell-ellipsis {
        text-align: center;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/global.css"],"names":[],"mappings":"AAAA;;IAEI,SAAS;IACT,UAAU;IACV;;oFAEgF;AACpF;;AAEA;;IAEI,SAAS;IACT,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,YAAY;AAChB;;AAEA;IACI;;iCAE6B;IAC7B,OAAO;AACX;;AAEA;IACI;;iCAE6B;IAC7B,QAAQ;AACZ;;AAEA;IACI,iEAA6D;IAC7D,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,wBAAwB;IACxB,WAAW;IACX,UAAU;IAEV,oCAAoC;AACxC;;AAEA;IACI,iEAA6D;IAC7D,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,WAAW;IACX,UAAU;IACV,kBAAkB;IAElB,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;AACJ","sourcesContent":["html,\nbody {\n    margin: 0;\n    padding: 0;\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\n        \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif,\n        \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n}\n\n[data-arrow=\"left\"],\n[data-arrow=\"right\"] {\n    bottom: 0;\n    height: 42px;\n    margin-bottom: 24px;\n    margin-top: auto;\n    width: 39px;\n    position: fixed;\n    margin-left: 160px;\n    opacity: 1;\n    cursor: pointer;\n    z-index: 999;\n}\n\n[data-arrow=\"left\"] {\n    background: linear-gradient(90deg,\n            var(--chakra-colors-brand-500) 10%,\n            hsla(0, 0%, 100%, 0));\n    left: 0;\n}\n\n[data-arrow=\"right\"] {\n    background: linear-gradient(270deg,\n            var(--chakra-colors-brand-500) 10%,\n            hsla(0, 0%, 100%, 0));\n    right: 0;\n}\n\n[data-arrow=\"left\"]>button {\n    background: url(\"../../public/icons/arrow.png\") 50% no-repeat;\n    border: none;\n    cursor: pointer;\n    height: 40px;\n    /* margin-left: 150px; */\n    width: 100%;\n    outline: 0;\n    -webkit-transform: rotate(180deg) scale(0.7);\n    transform: rotate(180deg) scale(0.7);\n}\n\n[data-arrow=\"right\"]>button {\n    background: url(\"../../public/icons/arrow.png\") 50% no-repeat;\n    border: none;\n    cursor: pointer;\n    height: 40px;\n    width: 100%;\n    outline: 0;\n    position: absolute;\n    -webkit-transform: scale(0.7);\n    transform: scale(0.7);\n}\n\n.menu-slider {\n    padding-right: 4.25rem;\n}\n\n.tableMenu {\n    .ant-table-cell-ellipsis {\n        text-align: center;\n    }\n\n    .ant-table-body .ant-table-cell:not(.ant-table-cell-with-append) {\n        text-align: center;\n    }\n\n    .ant-table-cell.ant-table-cell-ellipsis {\n        text-align: center;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
